import React, { createContext, useContext, useState } from 'react';
import { ContextStatus } from '@leedpulse-monorepo/enums';
import AuthenticationContext from '../../auth/AuthenticationContext';

import createDomain from '../../../../domain/use_cases/domains/createDomain';
import Domain from '../../../../domain/models/Domain';

interface DomainCreationFormContextProps {
  status: ContextStatus;
  name: string;
  description: string;
  tags: string[];
  positions: string[];
  onNameChange: (name: string) => void;
  onDescriptionChange: (description: string) => void;
  onTagsChange: (tags: string[]) => void;
  onPositionsChange: (positions: string[]) => void;
  submit: () => Promise<void>;
}

const DomainCreationFormContext = createContext<DomainCreationFormContextProps>(
  {
    status: ContextStatus.IDLE,
    name: '',
    description: '',
    tags: [],
    positions: [],
    onNameChange: (_: string) => {return;},
    onDescriptionChange: (_: string) => {return;},
    onTagsChange: (_: string[]) => {return;},
    onPositionsChange: (_: string[]) => {return;},
    submit: async () => {return;},
  }
);

export const DomainCreationFormProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const [status, setStatus] = useState(ContextStatus.IDLE);
  const [name, setName] = useState<string>('');
  const [description, setDescription] = useState<string>('');
  const [tags, setTags] = useState<string[]>([]);
  const [positions, setPositions] = useState<string[]>([]);

  const authContext = useContext(AuthenticationContext);

  const onNameChange = (newName: string) => {
    setName(newName);
  };

  const onDescriptionChange = (newDescription: string) => {
    setDescription(newDescription);
  };

  const onTagsChange = (newTags: string[]) => {
    setTags(newTags);
  };

  const onPositionsChange = (newPositions: string[]) => {
    setPositions(newPositions);
  };

  const submit = async () => {
    if (!authContext.authentication) return;

    setStatus(ContextStatus.LOADING);
    try {
      const domain = new Domain(
        Domain.generateDomainId(),
        name,
        description,
        tags,
        positions,
        [],
        new Date(),
        new Date(),
        { prompt: '', first_message: '', activities: [], motifs: [] },
        false
      );
      await createDomain(domain, authContext.authentication);
      setStatus(ContextStatus.SUCCESS);
    } catch (error) {
      console.error('Error creating domain:', error);
      setStatus(ContextStatus.ERROR);
    }
  };

  return (
    <DomainCreationFormContext.Provider
      value={{
        status,
        name,
        description,
        tags,
        positions,
        onNameChange,
        onDescriptionChange,
        onTagsChange,
        onPositionsChange,
        submit,
      }}
    >
      {children}
    </DomainCreationFormContext.Provider>
  );
};

export default DomainCreationFormContext;
